<template>
  <div class="no-access-container">
    <div class="content-wrapper">
      <i class="fa-solid fa-ban access-denied-icon"></i>
      <h6 class="title">You no longer have access to this proposal.</h6>
    </div>
    
    <a href="https://vertexcybersecurity.com.au" rel="noopener" class="logo-link">
      <img :src="logo" alt="Vertex Cyber Security Logo" class="logo">
    </a>
  </div>
</template>

<script>
import vertexLogo from '@/assets/img/vertex_logo.png';

export default {
  name: 'ProposalNoAccess',
  data() {
    return {
      logo: vertexLogo,
    };
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');

.no-access-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-image: url("~@/assets/img/BG_Mountain.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-family: 'Roboto', sans-serif;
  text-align: center;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 40px 60px;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.access-denied-icon {
  width: 80px;
  height: 80px;
  font-size: 80px; 
  color: #d9534f;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: check-fade-in 1s ease-in-out forwards;
}

.title {
  font-size: 1.7rem; 
  font-weight: 500;
  color: #333;
  margin: 20px 0 10px;
  opacity: 0;
  animation: fade-in 1s ease-in-out 0.5s forwards; 
}

/* Added style for the link wrapper to handle the animation and hover state */
.logo-link {
  text-decoration: none;
  display: inline-block;
  opacity: 0;
  animation: fade-in 1s ease-in-out 1.8s forwards;
  transition: transform 0.2s ease;
}

.logo-link:hover {
  transform: scale(1.02); /* Slight scale effect on hover */
}

.logo {
  max-width: 250px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 5px 10px;
  cursor: pointer;
}

/* Animations */
@keyframes fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes check-fade-in {
  from { opacity: 0; transform: scale(0.8); }
  to { opacity: 1; transform: scale(1); }
}
</style>